import React from "react";

const Content: React.FC = ({ children }) => {
  return (
    <div style={{ padding: "10px" }}>
      <div>{children}</div>
    </div>
  );
};

export default Content;
